var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.src)?_c('div',{staticClass:"preview_img_box"},[_c('img',{staticClass:"preview_img",attrs:{"preview":"","preview-text":"","src":_vm.imgSrc,"alt":""}}),_c('div',{staticClass:"preview_btn"},[_vm._v("点击查看大图")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }